import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";
import hi from "./locales/hi.json";
import ar from "./locales/ar.json";
import id from "./locales/id.json";
import de from "./locales/de.json";
import ja from "./locales/ja.json";
import ru from "./locales/ru.json";

// Detect language from URL path
const pathLang = window.location.pathname.split("/")[1];

// All supported languages
const supportedLangs = ["en", "fr", "es", "pt", "hi", "ar", "id", "de", "ja", "ru"];

// If URL has valid lang → use it, else English
const currentLang = supportedLangs.includes(pathLang) ? pathLang : "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      pt: { translation: pt },
      hi: { translation: hi },
      ar: { translation: ar },
      id: { translation: id },
      de: { translation: de },
      ja: { translation: ja },
      ru: { translation: ru }
    },
    lng: currentLang,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

// Important for react-snap & SEO
document.documentElement.lang = currentLang;

export default i18n;